// extracted by mini-css-extract-plugin
export default {"options":"bkdc2","options__group":"CSU4K"};